import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';

import { bytesToSize, createDownloadPopup, isImageFile } from '@appshared';
import { fuseAnimations } from '../../animations';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { locale as english } from './i18n/en';
import { locale as vietnam } from './i18n/vn';
import { PreviewModel } from './preview-dialog.model';

@Component({
  selector: 'fuse-preview-dialog',
  templateUrl: './preview-dialog.component.html',
  styleUrls: ['./preview-dialog.component.scss'],
  animations: fuseAnimations,
})
export class FusePreviewDialogComponent implements OnInit, OnDestroy {
  bytesToSize = bytesToSize;

  data: PreviewModel;
  canDisplay: boolean;

  subscriber: Subscription;

  constructor(
    public _dialogRef: MatDialogRef<FusePreviewDialogComponent>,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private readonly httpClient: HttpClient
  ) {
    this._fuseTranslationLoaderService.loadTranslations(english, vietnam);
  }
  ngOnDestroy(): void {
    this.subscriber?.unsubscribe();
  }

  ngOnInit(): void {
    this._dialogRef.updateSize('1376px');
    this._dialogRef.addPanelClass('artstuff-dialog-modal');

    const fileName = this.data.review ? this.data.review.fileName : this.data.preview.fileName;
    this.canDisplay = isImageFile(fileName);
  }

  downloadAttachment(): void {
    this.subscriber = this.httpClient
      .get(this.data.review.downloadUrl, { responseType: 'blob' })
      .subscribe(val => createDownloadPopup(val, this.data.review.fileName));
  }

  closeDialog(): void {
    this._dialogRef.close(false);
  }

  // close the dialog, while set 'true' to the return value --> delete this attachment
  removeFile(): void {
    this._dialogRef.close(true);
  }
}
